import { format } from "date-fns";
import { Loader2 } from "lucide-react";

const localLabel = (iso) => new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false });

export const SlotGrid = ({ date, slots, loading, selected, onSelect }) => {
  if (!date) {
    return (
      <div className="flex min-h-[260px] items-center justify-center border border-dashed border-white/10 p-6 text-center" data-testid="slot-grid-empty">
        <p className="max-w-[16rem] text-sm text-slate-500">Select a weekday on the calendar to see available times.</p>
      </div>
    );
  }
  if (loading) {
    return (
      <div className="flex min-h-[260px] items-center justify-center" data-testid="slot-grid-loading">
        <Loader2 className="h-5 w-5 animate-spin text-gold" />
      </div>
    );
  }
  const open = slots.filter((s) => s.available);
  const sample = slots[0];
  const tzDiffers = sample && localLabel(sample.start) !== sample.label;

  return (
    <div data-testid="slot-grid">
      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
        {format(date, "EEEE d MMMM")} · {open.length} slot{open.length === 1 ? "" : "s"} open
      </p>
      {open.length === 0 ? (
        <p className="mt-6 text-sm text-slate-400" data-testid="slot-grid-none">
          No times left on this day — please choose another date.
        </p>
      ) : (
        <div className="mt-4 grid max-h-[300px] grid-cols-2 gap-2 overflow-y-auto pr-1 sm:grid-cols-3 md:grid-cols-2 lg:grid-cols-3">
          {slots.map((s) => {
            const active = selected?.start === s.start;
            return (
              <button
                key={s.start}
                type="button"
                disabled={!s.available}
                data-testid={`slot-${s.label.replace(":", "")}`}
                onClick={() => onSelect(s)}
                className={`flex flex-col items-center border px-2 py-2.5 font-mono text-xs tracking-[0.15em] transition-colors ${
                  active
                    ? "border-gold bg-gold text-ink"
                    : s.available
                      ? "border-white/15 text-slate-200 hover:border-gold hover:text-gold"
                      : "cursor-not-allowed border-white/5 text-slate-700 line-through"
                }`}
              >
                {s.label}
                {tzDiffers && s.available && (
                  <span className={`mt-0.5 text-[9px] ${active ? "text-ink/70" : "text-slate-500"}`}>{localLabel(s.start)} local</span>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
